var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr'),_c('grid',{ref:"grid",staticClass:"no-grid-border",attrs:{"config":_vm.gridConfig},on:{"onPath":_vm.handlerPatch,"editor-custom-behaviour":_vm.handlerEditorCustomBehaviour}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }